import { Injectable } from '@angular/core';
import { MessageSocketRepositoryService } from 'src/app/module/chat/data/repository/message/message-live-signalr-data-source.service';
import { XTracerAsync } from 'src/app/services/monitoring/opentelemetry/tracer';
import { IMessageSocketRepository } from '../repository/message/message-socket-repository';

@Injectable({
  providedIn: 'root'
})
export class SocketConnectUseCaseService {

  constructor(
    private MessageSocketRepositoryService: IMessageSocketRepository
  ) { }

  @XTracerAsync({name:'SocketConnectUseCaseService', module:'chat',  bugPrint: true})
  async execute() {
    return await this.MessageSocketRepositoryService.connect()
  }


}
